import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomeAlertModal.css';

const HomeAlertModal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const storageKey = 'devtracker_neural_ingress_alert_acknowledged';

    useEffect(() => {
        const hasAcknowledge = localStorage.getItem(storageKey);
        if (!hasAcknowledge) {
            // Slight delay for "WOW" entrance effect
            const timer = setTimeout(() => setIsVisible(true), 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcknowledge = () => {
        localStorage.setItem(storageKey, 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="home-alert-overlay">
            <div className="home-alert-modal glass-card animate-scale-up">
                <div className="alert-header">
                    <div className="alert-badge neon-border">DevTracker SYSTEM ALERT</div>
                    <i className="fa-solid fa-triangle-exclamation alert-icon-main"></i>
                </div>
                
                <div className="alert-body">
                    <h2 className="alert-title">Important System Update</h2>
                    <div className="alert-message-box">
                        <p className="warning-text">
                            <strong>[!] CAUTION:</strong> The AI Assistant and Resume Builder are currently down for maintenance. We are working hard to fix them soon!
                        </p>
                        <p className="security-text">
                            <strong>[S] SECURITY:</strong> Security Patch 4.3.0 has been deployed to protect your profile data and prevent unauthorized access.
                        </p>
                        <p className="policy-text">
                            <strong>[i] LEGAL UPDATE:</strong> We have updated our <Link to="/privacy" className="policy-link" onClick={handleAcknowledge}>Privacy Policy</Link> and <Link to="/terms" className="policy-link" onClick={handleAcknowledge}>Terms of Service</Link> to make them much easier to read.
                        </p>
                    </div>
                </div>

                <div className="alert-footer">
                    <button className="btn btn-primary btn-glow acknowledge-btn" onClick={handleAcknowledge}>
                        I UNDERSTAND
                    </button>
                    <div className="alert-auto-dismiss">Please click to dismiss.</div>
                </div>
            </div>
        </div>
    );
};

export default HomeAlertModal;
